// extracted by mini-css-extract-plugin
var _1 = "Table_body__30497";
var _2 = "Table_cell__5d944";
var _3 = "Table_cellHeader__99c1a";
var _4 = "Table_center__205dc";
var _5 = "Table_checkboxHeader__e5820";
var _6 = "Table_disabledRow__84b66";
var _7 = "Table_emptyWrapper__a0680";
var _8 = "Table_free__ac2c7";
var _9 = "Table_header__6954c";
var _a = "Table_headerCell__5ef70";
var _b = "Table_left__039e5";
var _c = "Table_loader__f2e57";
var _d = "Table_loaderRow__2410b";
var _e = "Table_noBordersHeader__5e358";
var _f = "Table_right__5a35f";
var _10 = "Table_root__619b6";
var _11 = "Table_row__5f802";
var _12 = "Table_sticky__1913b";
var _13 = "Table_stickyCheckbox__3edd2";
var _14 = "Table_tableFooter__6f286";
var _15 = "Table_tableWrapper__4e242";
var _16 = "Table_withBourders__a4e84";
var _17 = "Table_wrapperPagination__2f93e";
export { _1 as "body", _2 as "cell", _3 as "cellHeader", _4 as "center", _5 as "checkboxHeader", _6 as "disabledRow", _7 as "emptyWrapper", _8 as "free", _9 as "header", _a as "headerCell", _b as "left", _c as "loader", _d as "loaderRow", _e as "noBordersHeader", _f as "right", _10 as "root", _11 as "row", _12 as "sticky", _13 as "stickyCheckbox", _14 as "tableFooter", _15 as "tableWrapper", _16 as "withBourders", _17 as "wrapperPagination" }
